import React, { Component } from "react";
import domain from "../../../../domain";
import axios from "axios";
import decode from "jwt-decode";
import moment from "moment";
import {
  Table,
  TableHeader,
  TableRow,
  TableHeaderCell,
  TableBody,
  TableCell,
} from "semantic-ui-react";
// const colors=[
//     'violet',

//   ]
export default class HomePage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      lecturer_name: "",
      topic: "",
      start_time: "",
      end_time: "",
      data: null,
      trainee_id: "",
      username: "",
      name: "",
      course_session_id: "",
      course_title: "",
      course_start: "",
      course_end: "",
    };
  }

  sessionwisedetails() {
    const { id, username, name } = decode(localStorage.getItem("token"));
    axios
      .get(`${domain.DBServer}/get-session/${id}`)
      .then((result) => {
        // console.log(result.data)
        this.setState({
          data: result.data,
          trainee_id: id,
          submission_count: result.data[0].submission_count,
          username: username,
          name: name,
        });
      })
      .catch((error) => {
        console.error("error: ", error);
      });
  }

  fetchCourseByTraineeId() {
    //  console.log('here')
    const { id } = decode(localStorage.getItem("token"));

    axios
      .get(`${domain.DBServer}/fetch-course-trainee/${id}`)
      .then((result) => {
        //  console.log(result);
        this.setState({
          course_title: result.data[0].title,
          course_start: result.data[0].start_date,
          course_end: result.data[0].end_date,
          loading: false,
          error: false,
        });
      })
      .catch((error) => {
        console.error("error: ", error);
        this.setState({
          error: `${error}`,
          loading: false,
        });
      });
  }

  componentDidMount() {
    this.sessionwisedetails();
    this.fetchCourseByTraineeId();
  }
  render() {
    let sessions;

    if (this.state.data) {
      sessions = this.state.data.map((result, key) => {
        return (
          <TableRow key={key} fullwidth="true">
            <TableCell>{key + 1}</TableCell>

            <TableCell width={3}>{result.lecturer_name}</TableCell>
            <TableCell width={5}>{result.title}</TableCell>
            <TableCell width={2} verticalAlign="top">
              {moment(result.session_date).format("LL")}
            </TableCell>
            <TableCell width={2}>
              {moment(result.start_time, "h:mm a").format("HH:mm a")}
            </TableCell>
            <TableCell width={2}>
              {moment(result.end_time, "h:mm a").format("HH:mm a")}
            </TableCell>
          </TableRow>
        );
      });
    }
    return (
      <div className="row">
        <div className="col s12 m12">
          <div className="card ">
            <div className="card-content">
              {/* <h2 style={{textAlign:"left",color:"#3f51b5",padding:"0",margin:"0"}}>Welcome {this.state.name} </h2>
          <Link to="/feedbackMenu/HomePage"><button  className="ui teal button ">Click here to provide feedback</button></Link> */}
              <hr />
              {/* <h3 style={{textAlign:"center",color:"blue",padding:"0",margin:"0"}}> Thank you for attending the trianing Program </h3> */}
              <h3
                style={{
                  textAlign: "center",
                  color: "#3f51b5",
                  padding: "0",
                  margin: "0",
                }}
              >
                {" "}
                Program Schedule{" "}
              </h3>
              <h3 style={{ textAlign: "center", color: "#3f51b5" }}>
                Course Title: {this.state.course_title}{" "}
              </h3>
              <h3 style={{ textAlign: "center", color: "#3f51b5" }}>
                {moment(this.state.course_start).format("LL")} To{" "}
                {moment(this.state.course_end).format("LL")}{" "}
              </h3>

              <Table selectable color="violet" striped>
                <TableHeader>
                  <TableRow>
                    <TableHeaderCell>S. No</TableHeaderCell>
                    <TableHeaderCell>Lecturer Name</TableHeaderCell>
                    <TableHeaderCell>Title of Lecture</TableHeaderCell>
                    <TableHeaderCell>Session Date</TableHeaderCell>
                    <TableHeaderCell>Start time</TableHeaderCell>
                    <TableHeaderCell>End Time</TableHeaderCell>
                  </TableRow>
                </TableHeader>

                <TableBody>{sessions}</TableBody>
              </Table>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
